const listItems = document.querySelectorAll('li.menu-item-has-children > .Navigation__subMenuLink__open');
const goBackBtns = document.querySelectorAll('.Navigation__subMenu__go-back');

const query = window.matchMedia('(max-width: 1024px)');

const initSubMenuFunctionality = () => {
    goBackBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const parentUl = btn.closest('ul');
            parentUl.classList.remove('open');
        });
    });

    const handleSubMenu = (ev) => {
        ev.preventDefault();
        const clickedLink = ev.currentTarget;
        const parent = clickedLink.closest('li');
        const nestedMenu = parent.querySelector('ul');
        nestedMenu.classList.add('open');
    };

    listItems?.forEach((listItem) => listItem.addEventListener('click', handleSubMenu));
};

if (query.matches) {
    initSubMenuFunctionality();
}

const handleMenuMobile = (param) => {
    if (param.matches) {
        initSubMenuFunctionality();
    }
};

query.addEventListener('change', handleMenuMobile);

// Mega menu

const mega_menu = document.querySelectorAll('.mega_menu');

if (mega_menu.length > 0) {
    function updateStyles() {
        const wrapper = document.querySelector('.megaMenu__wrapper');

        if (!wrapper) return;

        const wrapperRect = wrapper.getBoundingClientRect();
        const wrapperRight = wrapperRect.right;

        mega_menu.forEach((menu) => {
            const child = menu.querySelector('.Navigation__subMenu.Navigation__subMenuMega');
            if (!child) return;

            if (window.innerWidth > 1023) {

                child.style.left = "auto";

                const menuRect = menu.getBoundingClientRect();
                const menuRight = menuRect.right;

                const offset = menuRight - wrapperRight;

                child.style.right = `0px`;

            } else {
                child.style.left = "";
                child.style.right = "";
                child.style.width = "";
                child.style.maxWidth = "";
            }
        });
    }

    window.addEventListener('load', updateStyles);
    window.addEventListener('resize', updateStyles);
}


document.addEventListener('DOMContentLoaded', function () {
    const parentItems = document.querySelectorAll('.submenu_Parent .Navigation__subMenuItem');

    parentItems.forEach(parent => {
        const targetId = parent.dataset.target;
        const childList = document.getElementById(targetId);

        if (!childList) return;

        // Połącz parent i child w jeden obszar hover
        const hoverWrapper = [parent, childList];

        hoverWrapper.forEach(el => {
            el.addEventListener('mouseenter', () => {
                childList.classList.add('is-hover');
            });
            el.addEventListener('mouseleave', () => {
                // Sprawdź, czy kursor nie jest nad drugim elementem
                const isHovering = hoverWrapper.some(e => e.matches(':hover'));
                if (!isHovering) {
                    childList.classList.remove('is-hover');
                }
            });
        });
    });
});
